module.exports = __webpack_public_path__ + "static/media/new_nutrition_icon.fabbf719.png";